import { render, staticRenderFns } from "./Platform.vue?vue&type=template&id=4a532994"
import script from "./Platform.vue?vue&type=script&lang=ts"
export * from "./Platform.vue?vue&type=script&lang=ts"
import style0 from "./Platform.vue?vue&type=style&index=0&id=4a532994&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports